// extracted by mini-css-extract-plugin
export var avatar = "_r0-3";
export var avatarContainer = "_r0-2";
export var avatarSpacer = "_r0-5";
export var avatarSpacerContainer = "_r0-4";
export var avatarStackContainer = "_r0-1";
export var bubble = "_r0-0";
export var remainderBubble = "_r0-6";